import React, {useState} from 'react';
import PropTypes from 'prop-types';

/* Molecules (baseline) */
import {AlertDanger} from '../baseline/baseline';

export const AlertDangerWithState = ({msg}) => {
    const [errorMsg, setErrorMsg] = useState(msg);

    return (
        <AlertDanger
            msg={errorMsg}
            dismissible
            onAlertClosed={() => {
                setErrorMsg({errorMsg: null});
            }}
        />
    );
};

AlertDangerWithState.propTypes = {
    msg: PropTypes.string,
};
